// policy.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Policy, PaginatedPolicyResponse } from '../../models/policy.interface';
import { UrlReferenceService } from './url-reference.service';
import { environment } from '../../../assets/environments/environment.qa';

export interface PaymentSource {
  name?: string;
  number?: string;
  cvc?: string;
  month?: string;
  year?: string;
  _ds?: boolean;
  type: string;
}

export interface StcPaySource {
  mobile?: string;
  cashier?: string;
  branch?: string;
  type: string;
}

export interface TokenSource {
  type: string;
  token?: string;
  _ds?: boolean;
  manual?: boolean;
}

export interface PaymentRequestDto {
  amount: number;
  currency: string;
  description: string;
  callback_url: string;
  source?: PaymentSource;
  stcPay?: StcPaySource;
  tokenSource?: TokenSource;
}

export interface PaymentResponse {
  id: string;
  status: string;
  amount: number;
  currency: string;
  description: string;
  source: any;
  created_at: string;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private http: HttpClient, private urlRef: UrlReferenceService) {}

  // initate payment
  initiatePayment(paymentData: any): Observable<any> {
    return this.http.post<any>(
      `${environment.backend.PaymentService?.baseApiUrl}/initiate`,
      paymentData
    );
  }

  createPayment(
    paymentRequest: PaymentRequestDto,
    userId: string,
    companyId: string
  ): Observable<PaymentResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post<PaymentResponse>(
      `${environment.backend.PaymentService?.baseApiUrl}/create?userId=${userId}&companyId=${companyId}`,
      paymentRequest,
      { headers }
    );
  }

  verifyPayment(
    paymentId: string,
    quotaresponceId: string
  ): Observable<PaymentResponse> {
    return this.http.get<PaymentResponse>(
      `${environment.backend.PaymentService?.baseApiUrl}/${paymentId}?quoteResponseId=${quotaresponceId}`
    );
  }
}
